import { render, staticRenderFns } from "./reset-pwd.vue?vue&type=template&id=4621fcc2&scoped=true"
import script from "./reset-pwd.vue?vue&type=script&lang=js"
export * from "./reset-pwd.vue?vue&type=script&lang=js"
import style0 from "./reset-pwd.vue?vue&type=style&index=0&id=4621fcc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4621fcc2",
  null
  
)

export default component.exports